import apiSlice from "./apiSlice";

const procurementDashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProcurementProgressKpi: builder.query({
            query: ({ projectId }) => ({
                url: `Procurement/progress-kpi`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProcurementProgressKpi"],
        }),

        getProcurementPlanVsActual: builder.query({
            query: ({ projectId }) => ({
                url: `Procurement/plan-vs-actual`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProcurementPlanVsActual"],
        }),

        getProcurementProgressCurve: builder.query({
            query: ({ projectId }) => ({
                url: `Procurement/progress-curve`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProcurementProgressCurve"],
        }),

        getProcurementVarianceDrivers: builder.query({
            query: ({ projectId, month }) => ({
                url: `Procurement/variance-drivers`,
                params: {
                    projectId,
                    ...(month ? { month } : {}),
                },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProcurementVarianceDrivers"],
        }),
    }),
});

export const {
    useGetProcurementProgressKpiQuery,
    useGetProcurementPlanVsActualQuery,
    useGetProcurementProgressCurveQuery,
    useGetProcurementVarianceDriversQuery,
} = procurementDashboardApiSlice;
